import React from 'react';
import { buttonStyle, sectionHeaderStyle } from './styles';

interface NetworkActionsProps {
  isConnected: boolean;
  onAction: (action: string, data?: any) => void;
}

export const NetworkActions: React.FC<NetworkActionsProps> = ({ isConnected, onAction }) => {
  return (
    <>
      <div style={sectionHeaderStyle}>Network Actions</div>
      <button
        style={{ ...buttonStyle, textAlign: 'center', background: isConnected ? 'rgba(231, 76, 60, 0.2)' : 'rgba(46, 204, 113, 0.2)' }}
        onClick={() => onAction(isConnected ? 'disconnect' : 'connect_server')}
      >
        {isConnected ? '🔌 Disconnect' : '🔌 Connect to Server'}
      </button>
      <div style={{ display: 'flex', gap: '5px' }}>
        <button style={{ ...buttonStyle, flex: 1, textAlign: 'center' }} onClick={() => onAction('debug_state')}>
          🔍 Debug State
        </button>
        <button style={{ ...buttonStyle, flex: 1, textAlign: 'center' }} onClick={() => onAction('force_sync_stats')}>
          🔄 Force Sync
        </button>
      </div>
    </>
  );
};
